import { render, staticRenderFns } from "./FaturamentoCard.vue?vue&type=template&id=6759ac3f"
import script from "./FaturamentoCard.vue?vue&type=script&lang=js"
export * from "./FaturamentoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports